import type { InputProps } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import { forwardRef, ReactNode } from 'react'
import HintLabel from '../HintLabel'
import InputBase from './InputBase'

type _InputProps = Omit<InputProps, 'inputProps'>

interface CommonProps {
  labelHint?: string
  helperText?: ReactNode
  minValue?: number
  maxValue?: number
}

type Props =
  | (_InputProps &
      CommonProps & {
        label?: ReactNode
        placeholder: string
      })
  | (_InputProps &
      CommonProps & {
        label: ReactNode
        placeholder?: string
      })

const NumberField = forwardRef((props: Props, _) => {
  const {
    label,
    labelHint,
    onChange,
    helperText,
    minValue,
    maxValue,
    disabled,
    sx,
    ...inputProps
  } = props

  const handleChange = (e) => {
    let result = e.target.value as any

    if (result.length) {
      result = parseFloat(result)

      if (Number.isFinite(minValue)) {
        result = Math.max(minValue, result)
      }

      if (Number.isFinite(maxValue)) {
        result = Math.min(maxValue, result)
      }

      onChange?.({ target: { value: Number(result) } } as any)
      return
    }

    onChange?.({ target: { value: String(result) } } as any)
  }

  return (
    <FormControl
      error={inputProps.error}
      disabled={disabled}
      sx={sx}
      variant="standard"
    >
      <HintLabel htmlFor={inputProps.id} hint={labelHint}>
        {label}
      </HintLabel>
      <InputBase
        {...inputProps}
        onChange={handleChange}
        type="number"
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
})

export default NumberField
